import PageHeader from "./PageHeader";
import PostSidebar from "./PostSidebar";
import PostEditor from "./PostEditor";
import PostSeoPanel from "./PostSeoPanel";

export default function PostEditorLayout({
    title,
    subtitle,
    buttonLabel,
    onSubmit,
    saving,

    formData,
    updateField,

    imagePreview,
    onImageChange,

    ogImagePreview,
    onOgImageChange,

    categories,
}) {
    return (
        <div className="space-y-8">

            <PageHeader
                title={title}
                subtitle={subtitle}
                actionButton={
                    <button
                        onClick={onSubmit}
                        disabled={saving}
                        className="
                            px-8
                            py-3
                            rounded-xl
                            bg-blue-800
                            text-white
                            font-semibold
                        "
                    >
                        {saving ? "Saving..." : buttonLabel}
                    </button>
                }
            />

            <div className="grid xl:grid-cols-3 gap-8">

                <div className="xl:col-span-2 space-y-8">

                    <PostEditor
                        formData={formData}
                        updateField={updateField}
                    />

                    <PostSeoPanel
                        formData={formData}
                        updateField={updateField}
                        ogImagePreview={ogImagePreview}
                        onOgImageChange={onOgImageChange}
                    />

                </div>

                <div>

                    <PostSidebar
                        formData={formData}
                        updateField={updateField}
                        imagePreview={imagePreview}
                        onImageChange={onImageChange}
                        categories={categories}
                    />

                </div>

            </div>



        </div>
    );
}